export default __webpack_public_path__ + "static/media/img-industry-other.12415558.svg";